import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { KeyValue } from '../details/offer';
import { DevelopmentHelpers } from '../../shared/utilities/developHelpers';
import { DeepRef } from '../../shared/utilities/shared.functions';

@Component({
  selector: 'input-with-options',
  templateUrl: './input-with-options.component.html',
  styleUrls: ['./input-with-options.component.css']
})
export class InputWithOptionsComponent implements OnInit {

  @Input('value') in: string;
  @Output('valueChange') out = new EventEmitter<string>();
  @Input('options') o: { options: Array<any>, key: string, value: string };
  inputValue: string = '';
  inFocus = false;
  shownOptions: Array<KeyValue> = [];
  isHovering = '';
  highlightIndex = -1;

  constructor() { }

  ngOnInit() {

  }

  ngOnChanges(c: SimpleChanges) {
    if(!!c.in && c.in.currentValue != c.in.previousValue) {
      // let found = this.o.options.find(x => DeepRef.getValue(x, this.o.key) == c.in.currentValue);
      // this.inputValue = !!found ? DeepRef.getValue( found, this.o.value) : '';
      this.setInputVal();
      this.shownOptions = this.remapValue(this.o.options);
    }
  }

  setInputVal() {
    let found = this.o.options.find(x => DeepRef.getValue(x, this.o.key) == this.in);
    this.inputValue = !!found ? DeepRef.getValue( found, this.o.value) : '';
  }

  remapValue(options){
    return options.map(x => ({
      key: DeepRef.getValue(x, this.o.key),
      value: DeepRef.getValue(x, this.o.value)
    }));
  }

  focus() {
    this.inFocus = true;
    this.inputValue = '';
  }

  blurOut() {
    setTimeout(() => {
      this.inFocus = false;
      this.out.emit(this.in);
    }, 200);
  }

  filter(event:KeyboardEvent) {
    if (event.code == 'Enter') { 
      event.preventDefault();
      this.in = this.highlightIndex != -1 ? 
        this.shownOptions[this.highlightIndex].key : 
        this.shownOptions.length == 1 ? 
        this.shownOptions[0].key : 
        this.in; 
      this.inFocus = false; 
      this.out.emit(this.in); 
      this.makeChange();
      this.setInputVal();
    }
    else if (event.code == 'ArrowUp' || event.code == 'ArrowDown') {event.preventDefault(); this.highlightIndex += event.code == 'ArrowDown' ? 1 : -1 }
    else if(event.code == 'Backspace') {
      this.shownOptions = this.remapValue(this.o.options);
    }
    else {
      this.inFocus = true;
      event.preventDefault();
      this.highlightIndex = -1;
      if (!!this.inputValue && !!this.o && !!this.o.options.length) {
        let s = this.inputValue.toLowerCase();
        let filtered = this.o.options.filter(x => DeepRef.getValue(x, this.o.value).toLowerCase().match(s));
        this.shownOptions = this.remapValue(filtered);
        //this.inFocus = false;
      }
      else {
        // reset list
        //this.shownOptions = this.remapValue(this.o.options); 
        this.inFocus = false;
      }
    }
  }

  makeChange() {
    this.out.emit(this.in)
  }

}
